module.exports = __webpack_public_path__ + "img/not_found.1287e0da.svg";